export function addLibraryAwareObjectToWindow() {
    window.LA = $.extend({ ApplicationState: {}, Models: {}, Views: {}, Collections: {}, Events: {}, Routers: {}, Mixins: {}, Templates: {}, Promos: {}, Subscribers: {}, Admin: {}, Support: {}, Newsletters: {} }, window.LibraryAware);
}

export function namespace(ns, global) {
    var nsParts = typeof ns === "string" ? ns.split('.') : '';

    global = global || window;

    for (var i = 0, max = nsParts.length; i < max; i++) {
        var nsPart = nsParts[i];
        global[nsPart] = global[nsPart] || (global[nsPart] = {});
        global = global[nsPart];
    }

    return global;
}

export function addUtilityObjectToLibraryAwareObject() {
    LA.Utility = {
        //Extended JQuery GetScript function that conforms to Async.JS style.
        getScript: function (script, callback) {
            $.ajax({
                url: LA.WebRoot + 'Scripts/' + script,
                dataType: 'script',
                success: function () { if (callback) { callback(); } },
                error: function (jqXhr) { if (callback) { callback(jqXhr.status); } }
            });
        },

        getQueryStringVar: function (url, name) {
            var val = null;
            url = url.toLowerCase();
            name = name.toLowerCase();
            var arr = (new RegExp('(?:&|\\?)' + name + '=([^&]+)(?:&|$)')).exec(url);
            if (arr && arr.length > 1) {
                val = decodeURIComponent(arr[1].replace(/\+/g, '%20'));
            }
            return val;

        },

        //Fixes the capitalized first letter type naming scheme from C# objects coming off the server.
        fixCSharpPropertyNames: function (obj) {
            var fixed = {};
            for (var idx in obj) {
                if (obj.hasOwnProperty(idx)) {
                    fixed[idx.charAt(0).toLowerCase() + idx.slice(1)] = obj[idx];
                }
            }
            return fixed;
        },

        // Read a page's GET URL variables and return them as an object
        getQueryStringVars: function (url) {
            url = url || window.location.href;
            var vars = {}, hash;
            var hashes = url.slice(url.indexOf('?') + 1).split('&');
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars[hash[0]] = hash[1];
            }
            return vars;
        },

        parseLinkData: function (link) {
            var retval = {};

            if (link.toLowerCase().indexOf('persistentlink') !== -1) {
                //PersistentLink / EResource

                var params = LA.Utility.getQueryStringVars(link);
                delete params.EResourceId;
                delete params.PersistentLinkName;

                retval = {
                    href: '',
                    target: '_blank',
                    title: LA.Utility.getQueryStringVar(link, 'PersistentLinkName'),
                    data: {
                        'e-resource-id': LA.Utility.getQueryStringVar(link, 'EResourceId'),
                        'e-resource-name': '',
                        'hard-href': '',
                        'link-source': 'e-resource',
                        'p-link-name': LA.Utility.getQueryStringVar(link, 'PersistentLinkName'),
                        'parameters': JSON.stringify(params)
                    }
                };
            } else if (link.toLowerCase().indexOf('catalog?') !== -1) {
                //Catalog Link

                retval = {
                    href: '',
                    target: '_blank',
                    title: LA.Utility.getQueryStringVar(link, 'Title'),
                    data: {
                        'catalog-book-author': LA.Utility.getQueryStringVar(link, 'Author'),
                        'catalog-book-id': '1',
                        'catalog-book-isbn': LA.Utility.getQueryStringVar(link, 'Isbn'),
                        'catalog-book-upc': LA.Utility.getQueryStringVar(link, 'Upc'),
                        'catalog-book-title': LA.Utility.getQueryStringVar(link, 'Title'),
                        'catalog-book-record-id': '',
                        'catalog-book-record-source': 'kdh',
                        'link-source': 'catalog-book',
                        'hard-href': '',
                        'preferredLink': LA.Utility.getQueryStringVar(link, 'PreferredLink')
                    }
                };
            }

            return retval;
        },

        populateLinkInfo: function (link, linkMetadata, documentId, callback) {
            var linkInfo = {
                linkText: '',
                linkMetadata: linkMetadata
            };

            // Parse base link data if necessary.
            if ((!linkInfo.linkMetadata) && (!link || link.indexOf(LA.Domain) !== -1)) {
                linkInfo.linkMetadata = LA.Utility.parseLinkData(link);

                // If we're set up with a fresh un-parsed e-resource object..
                if (linkInfo.linkMetadata.data && linkInfo.linkMetadata.data['link-source'] === 'e-resource' && linkInfo.linkMetadata.data['e-resource-name'] === '') {
                    var erId = linkInfo.linkMetadata.data['e-resource-id'];

                    // We need to load the e-resource name off the server.
                    $.ajax({
                        url: LA.Path + '/EResources/Details/',
                        type: 'GET',
                        data: { id: erId },
                        success: function (data) {

                            // In the event we asked for an E-Resource that doesn't exist/the server couldn't find.
                            if (!data || !data.name) {
                                data = { name: 'Unknown E-Resource' };
                            }

                            // Update our link data - but only if we're still linked to the same e-resource.
                            if (linkInfo.linkMetadata && linkInfo.linkMetadata.data && linkInfo.linkMetadata.data['link-source'] === 'e-resource' && linkInfo.linkMetadata.data['e-resource-id'] === erId) {
                                linkInfo.linkMetadata.data['e-resource-name'] = data.name;
                            }

                            // Use the updated link metadata to generate link text.
                            LA.Utility.populateLinkInfo(link, linkInfo.linkMetadata, documentId, callback);
                        }
                    });

                    // Exit now so the callback is only invoked once.
                    return;

                }

            }

            if (!linkInfo.linkMetadata || !linkInfo.linkMetadata.data || linkInfo.linkMetadata.data['link-source'] === 'custom') {
                //This method is a little bit quirky; but at current there aren't a lot of good options.
                //Ideally we can have some better context-specific data to confirm this link.
                if (documentId && link.indexOf(documentId.toLowerCase()) !== -1) {
                    //Linked to this post.
                    linkInfo.linkText = 'Linked to an item in a folder';
                } else {
                    //Generic custom link (non-blank)
                    if (link) {
                        linkInfo.linkText = 'Custom Link: ' + link;
                    }
                }

                if (!linkInfo.linkMetadata || !linkInfo.linkMetadata.data) {
                    linkInfo.linkMetadata = {
                        data: {
                            'link-source': 'custom'
                        }
                    }
                }
            } else if (linkInfo.linkMetadata.data['link-source'] === 'e-resource') {
                linkInfo.linkText = 'E-Resource: ' + (linkInfo.linkMetadata.data['e-resource-name'] ? linkInfo.linkMetadata.data['e-resource-name'] : 'Loading...');
            } else if (linkInfo.linkMetadata.data['link-source'] === 'catalog-book') {
                linkInfo.linkText = 'Catalog Book: ' + linkInfo.linkMetadata.data['catalog-book-title'];
            } else if (linkInfo.linkMetadata.data['link-source'] === 'upload-file') {
                linkInfo.linkText = 'Uploaded File: ' + linkInfo.linkMetadata.data['uploaded-file-name'];
            } else {
                linkInfo.linkText = linkInfo.linkMetadata.data['link-source'];
            }

            linkInfo.linkText = linkInfo.linkText ? linkInfo.linkText : 'No Link';

            callback(linkInfo.linkText, linkInfo.linkMetadata);
        },


        //Validates LA.SocialMediaCache, and triggers the callback when completed.
        validateSocialMediaCache: function (callback, forceReload) {
            //If we've never loaded our social data, do it now.
            if (LA.SocialMediaCache === undefined || LA.SocialMediaCache === null || forceReload === true) {
                $.ajax({
                    url: LA.Path + '/socialmedia/GetAllSocialMediaAccounts',
                    type: 'GET',
                    success: function (data) {
                        LA.SocialMediaCache = {
                            Accounts: {},
                            TypeChannels: {}
                        };

                        for (var idx = 0; idx < data.accounts.length; idx++) {
                            LA.SocialMediaCache.Accounts[data.accounts[idx].accountId] = data.accounts[idx];
                        }
                        for (idx = 0; idx < data.channels.length; idx++) {
                            LA.SocialMediaCache.TypeChannels[data.channels[idx].entityType] = data.channels[idx];
                        }
                        if (callback) {
                            callback(null, LA.SocialMediaCache);
                        }
                    },
                    error: function (jqXhr) {
                        if (callback) {
                            callback(jqXhr.status);
                        }
                    }
                });
            } else {
                if (callback) {
                    callback(null, LA.SocialMediaCache);
                }
            }
        },

        shortUrlLength: function () {
            var prefix = LA.ShortUrlBase + LA.WebRoot;

            //SHORT_URL_ID_LENGTH = 5
            return prefix.length + 5;
        },
        getNotAuthorizedBanner: function (options) {
            LA.ajax({
                url: LA.WebRoot + 'notauthorized',
                type: 'GET'
            }, function (resp) {
                options.dispatcher.trigger(
                    'set:content',
                    resp,
                    '');
            });
        }
    };
}

export function addViewsMixinsObjectToLibraryAwareObject() {
    var mixins = LibraryAware.Utility.namespace('LA.Views.Mixins');

    mixins.CheckReset = {

        appRouter: null,

        bindReset: function (appRouter) {
            this.appRouter = appRouter;

            _.bindAll(this,
                'reset',
                'checkReset');

            // Bind us to destroy ourselves if we change page.
            // TODO: This should really not be done here.  This *should* be handled by a framework level removal.
            // TODO: Because such a framework doesn't exist in LA currently, we remove ourselves.
            this.appRouter.on('all', this.checkReset);
        },

        checkReset: function (eventName) {
            // Clean us up if we are routing away from this view.
            if (eventName.indexOf('route:') === 0) {
                this.reset();
            }
        },

        reset: function () {
            this.appRouter.off(null, this.checkReset);
            // Destroy our DOM element and other references, and unbind event handlers.
            this.remove();

            // We should now be automatically GC'd by the browser,
            // since we have no hanging references.
        }
    };

    mixins.DocumentManagement = {
        /// <summary> Mixins for pages to view documents (Promotions > Items) </summary>

        deleteDocument: function (promoId, docId, deliveryType) {
            var self = this;

            var doDelete = function () {
                $.post(LA.Path + '/Documents/Delete/' + docId, function (data) {
                    var message = !data.success ? data.error : null;
                    if (data.success) {
                        if (self.onDeleteSuccess) {
                            self.onDeleteSuccess(data);
                        }
                    }
                    if (message) {
                        $('<div>' + message + '</div>').modal({
                            title: 'Document Delete',
                            width: 350,
                            height: 150,
                            zIndex: 100010,
                            backdrop: 'static',
                            show: true,
                            buttons: [
                                {
                                    text: 'Ok',
                                    click: function () {
                                        this.hide();
                                    }
                                }
                            ]
                        });
                    }
                }, 'json');
            };
            var deleteConfirmationText = Res.Strings.Docs.confirmDeleteGeneric;
            switch (deliveryType) {
                case 'Print':
                    deleteConfirmationText = Res.Strings.Docs.confirmDeletePrintItem;
                    break;
                case 'Web':
                    deleteConfirmationText = Res.Strings.Docs.confirmDeleteWidgetSlide;
                    break;
                case 'Email':
                    deleteConfirmationText = Res.Strings.Docs.confirmDeleteEBlast;
                    break;
                case 'Letter':
                    deleteConfirmationText = Res.Strings.Docs.confirmDeleteMediaRelease;
                    break;
            }

            $('<div>' + deleteConfirmationText + '</div>').modal({
                title: 'Confirm Delete',
                width: 570,
                height: 'auto',
                zIndex: 100010,
                backdrop: 'static',
                show: true,
                buttons: [
                    {
                        text: 'Delete',
                        'class': 'btn-danger',
                        click: function () {
                            doDelete();
                            this.hide();
                        }
                    },
                    {
                        text: 'Cancel'
                    }
                ]
            });
        },

        previewDocument: function (previewUrl, deliveryType) {

            var requiredButtons = [];
            if (deliveryType !== 'Print') {
                requiredButtons.push({
                    text: 'Print',
                    click: function () {
                        var $iframe = $('#previewDocument');

                        if ($iframe.length > 0) {
                            var iw = $iframe[0].contentWindow || $iframe[0];
                            iw.focus();
                            iw.print();
                        }

                        this.hide();
                    }
                });
            }
            requiredButtons.push({ text: 'Close' });

            $('<div><iframe id="previewDocument" src="' + previewUrl + '" style="width:900px;height:458px;"></iframe></div>').modal({
                title: 'Document Preview',
                width: 940,
                height: 580,
                zIndex: 100010,
                buttons: requiredButtons,
                show: true,
                onLoad: function (modal) {
                    modal.find('iframe').on('load', function () {
                        var contents = $(this).contents();
                        contents.find('a').attr('target', '_blank');
                    });
                }
            });
        },

        loadImages: function () {
            $('img.lazy', this.$el).each(function (index, element) {
                var $img = $(element);
                var img = $img.get(0);
                var $wrapper = $img.parent();
                var $file = $wrapper.parent();
                var $loading = $file.prev();

                img.onload = function () {
                    $img.removeClass('lazy').removeAttr('data-src');
                    $loading.hide();
                    $file.css({ 'display': 'table-cell', 'text-align': 'center' });
                    $wrapper.fadeIn('fast').css('display', 'inline-block');
                };
                img.src = $img.attr('data-src');
            });
            $('div.no-image', this.$el).each(function (index, element) {
                var $div = $(element);
                var $wrapper = $div.parent();
                var $file = $wrapper.parent();
                var $loading = $file.prev();

                $loading.hide();
                $file.css({ 'display': 'table-cell', 'text-align': 'center' });
                $wrapper.fadeIn('fast').css('display', 'inline-block');
            });
        },

        setupDocumentDetails: function (modalTitle) {
            $('.file, div.name>a', this.$el).qtip({
                content: {
                    text: function () {
                        var $el = $(this);
                        if ($el.is('a')) {
                            return $('.details', $el.parent().parent()).html();
                        } else {
                            return $('.details', $el.parent()).html();
                        }
                    },
                    title: { text: modalTitle || 'Document Details', button: true }
                },
                position: { at: 'right center', my: 'left center' },
                show: { event: 'click', solo: true },
                hide: { event: 'unfocus scroll' },
                style: { classes: 'qtip-teal qtip-shadow qtip-rounded' },
                events: {
                    show: function (e) {
                        // if the original target is a user star, do not show the tool tip (return false)
                        var retval = true;
                        if ($(e.originalEvent.target).hasClass('userstar-placeholder')) {
                            retval = false;
                        }
                        return retval;
                    }
                }
            });

            $('body').on('click', 'a.doc-details-action', function (/*e*/) {
                $('.file, div.name>a', this.$el).qtip('toggle', false);
            });
        },

        unbindDocumentManagementEvents: function () {
            $('body').off('click', 'a.doc-details-action');
        }
    };
}
